<template>
  <model-select
    :options="options"
    :value="value"
    :placeholder="placeholder"
    @input="handleInput"
  >
  </model-select>
</template>

<script>
import 'vue-search-select/dist/VueSearchSelect.css';
import { ModelSelect } from 'vue-search-select';

export default {
  name: 'SelectDropdown',

  components: { ModelSelect },

  props: {
    value: { type: [String, Number] },
    options: { type: Array, required: true, default: () => [] },
    required: { type: Boolean, required: false, default: true },
    placeholder: { type: String, required: false },
  },

  methods: {
    handleInput(value) {
      this.$emit('input', value);
    },
  },
};
</script>
